module.exports = __webpack_public_path__ + "static/media/fleeDashboardEndIcon.4de2d9df.svg";